
// third-party imports

import "jquery";
Object.assign(window, { $: jQuery, jQuery });
import * as bootstrap from 'bootstrap'
Object.assign(window, { bootstrap });
import 'slick-carousel'
import 'jquery-ui'
import 'jquery.cookie'
import 'jquery.print'


